function getPunchoutEmail() {
  try {
    return (
      JSON.parse(localStorage.getItem("tokens") || "{}")?.punchout_email ?? null
    );
  } catch {
    return null;
  }
}

function runPo2go() {
  const L = window.PUNCHOUT_LABELS || {};
  const labels = {
    preparingCart: L.preparingCart || "Preparing cart…",
    preparingTransfer: L.preparingTransfer || "Preparing transfer…",
    emptyCartError:
      L.emptyCartError || "You cannot transfer an empty or a zero amount cart.",
    transferCart: L.transferCart || "Transfer Cart",
  };

  // Translate the modal strings hardcoded inside TradeCentric's core po2go.js
  // (e.g. "Preparing transfer..") which we can't edit. Wrap Basic.Modal.show once
  // and map known English strings to the locale-aware labels.
  if (window.Basic?.Modal && !window.Basic.Modal.__poTranslated) {
    const modalT = {
      "Preparing transfer..": labels.preparingTransfer,
      "Preparing Cart..": labels.preparingCart,
    };
    const _show = window.Basic.Modal.show.bind(window.Basic.Modal);
    window.Basic.Modal.show = function (msg) {
      return _show(modalT[msg] || msg);
    };
    window.Basic.Modal.__poTranslated = true;
  }

  const storeConfig = {
    punchout_only: 0,
    allow_zero_value_cart: false,
    graphql_token:"87bf9152af48de71e7d98eee000c0b57",
    cart_transfer_metafields: [
      "custom.unspsc",
      "custom.uom",
      "custom.eclass_5_1",
      "custom.eclass_7_1",
      "custom.eclass_10_1",
      "custom.eclass_11_1",
      "custom.taxrate",
      "custom.expecteddeliverydate",
      "custom.ofrex_category_code",
      "custom.manufacturerid",
      "custom.baseprice",
      // ...(window.SHOP_CONSTANTS?.SHOW_BASE_PRICE_EMAILS?.includes(
      //   getPunchoutEmail()
      // )
      //   ? ["custom.baseprice"]
      //   : []),
    ],
    transfer_label: labels.transferCart,
    custom_style: "body.punchout .cart-details-actionsRow {display:none}",
    checkout_selector: 'button[name="checkout"]',
    transfer_selector: 'button[name="transfer_items"]',
    transfer_btn_html: `<button type="submit" name="transfer_items" class="btn" onClick="POSession.extension.transferCart(); return false;" >${labels.transferCart}</button>`,
    return_selector: "#account-dropdown-root",
    return_btn_html:'<button type="button" name="close_punchout" class="btn btn--primary" onClick="POSession.cancel();"><span class="btn__text">Close PunchOut</span></button>',
  };

  window.POExt = new Po2go_Shopify(storeConfig);

  // Location language -> locale prefix (same logic as navigateToHome in Punchout.jsx)
  function poLocalePrefix() {
    let lang =
      window.customerData?.location_language ||
      (() => {
        try {
          return JSON.parse(localStorage.getItem("customer_data") || "{}")
            ?.location_language;
        } catch {
          return null;
        }
      })() ||
      window.locale ||
      "";
    lang = String(lang).toLowerCase();
    return lang && lang !== "de" ? `/${lang}` : "";
  }

  // Override transferCart to fetch the cart under the locale prefix, so Shopify
  // returns a localized product_title (in the location's language) instead of the
  // shop's default language. ext_shopify.js hardcodes "/cart.js" (root), so without
  // this the names always come back in the primary language regardless of the
  // locale the user was redirected to.
  window.POExt.transferCart = function () {
    const $ = window.jQuery;
    window.Basic.Modal.show(labels.preparingCart);
    $.ajaxSetup({ cache: false });

    const endpoint = `${poLocalePrefix()}/cart.js`; // e.g. /fr/cart.js

    $.ajax(endpoint, {
      method: "GET",
      dataType: "json",
      complete: $.proxy(function (info) {
        let cartData = info.responseJSON;
        if (typeof cartData === "undefined") {
          cartData = $.parseJSON(info.responseText);
        }
        this.collectMetafields().then((metafields) => {
          if (metafields.data) {
            metafields = this.parseMetafieldsResponse(metafields.data);
          }
          if (this.evaluateCart(cartData, metafields)) {
            this.deleteCart(cartData);
          } else {
            window.Basic.Modal.show(labels.emptyCartError);
          }
        });
      }, this),
    });
  };

  window.POSession = new Po2go({
    account: "",
    punchout_only: storeConfig.punchout_only,
    extension: window.POExt,
  });

  window.POSession.init();

  if (!window.POSession.return_url) {
    // Try localStorage first (set by our punchout login component)
    const stored = localStorage.getItem("punchout_return_url");
    if (stored) {
      window.POSession.return_url = stored;
    } else {
      // Fallback: read from URL params directly (handles &amp; and &amp%3B encoding)
      try {
        let search = window.location.search;
        try {
          search = decodeURIComponent(search);
        } catch (e) {}
        search = search.replace(/&amp;/g, "&");
        const params = new URLSearchParams(
          search.startsWith("?") ? search.slice(1) : search
        );
        const returnUrl = params.get("return_url");
        if (returnUrl) {
          window.POSession.return_url = returnUrl;
          localStorage.setItem("punchout_return_url", returnUrl);
        }
      } catch (e) {}
    }
  }

  window.POSession.extension.setupPage();
  window.POSession.extension.returnToProcButton(); // Add this if you need to add a Close PunchOut button; don't forget to add your return_selector and return_btn_html to the store_config
}

window.runPo2go = runPo2go;
